/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let Shrink: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M170.667008 170.667008v682.665984h682.665984V170.667008H170.667008z m0-56.889344h682.665984c31.419392 0 56.889344 25.469952 56.889344 56.889344v682.665984c0 31.419392-25.469952 56.889344-56.889344 56.889344H170.667008c-31.419392 0-56.889344-25.469952-56.889344-56.889344V170.667008c0-31.419392 25.469952-56.889344 56.889344-56.889344zM666.00448 398.22336H768c15.709184 0 28.444672 12.734464 28.444672 28.444672 0 15.70816-12.735488 28.443648-28.444672 28.443648H597.332992c-15.70816 0-28.443648-12.734464-28.443648-28.443648V256c0-15.709184 12.734464-28.444672 28.443648-28.444672 15.710208 0 28.444672 12.735488 28.444672 28.444672v101.99552l122.108928-122.108928c11.108352-11.108352 29.118464-11.108352 40.226816 0 11.108352 11.108352 11.108352 29.118464 0 40.226816L666.00448 398.222336zM357.99552 625.77664H256c-15.709184 0-28.444672-12.734464-28.444672-28.444672 0-15.70816 12.735488-28.443648 28.444672-28.443648h170.667008c15.70816 0 28.443648 12.734464 28.443648 28.443648V768c0 15.709184-12.734464 28.444672-28.443648 28.444672-15.710208 0-28.444672-12.735488-28.444672-28.444672v-101.99552L276.113408 788.113408c-11.108352 11.108352-29.118464 11.108352-40.226816 0-11.108352-11.108352-11.108352-29.118464 0-40.226816l122.108928-122.108928z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

Shrink.defaultProps = {
  size: 18,
};

Shrink = React.memo ? React.memo(Shrink) : Shrink;

export default Shrink;
